export const labels = {
	accept: {
		label: "Label.MobileCreator.ConfirmationBar.Accept",
		default: "Accept",
	},
	cancel: {
		label: "Label.MobileCreator.ConfirmationBar.Cancel",
		default: "Cancel",
	},
} as const;
